module.exports = __webpack_public_path__ + "img/wx.f67ab4c4.png";